
const digest = 'c11d3d1901cfe7351d14b4a813b047261a3c82b954c4104d0c843016932018ba';
const classes = {"item":"_item_3t53z_1","image":"_image_3t53z_13","name":"_name_3t53z_20","birthNumber":"_birthNumber_3t53z_26","badgeWrapper":"_badgeWrapper_3t53z_30","verificationWrapper":"_verificationWrapper_3t53z_35"};
const css = `._item_3t53z_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #d1d4da;
  padding: 24px;
  align-items: center;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  border-radius: 3px;
}
._item_3t53z_1 ._image_3t53z_13 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  margin-bottom: 15px;
  object-fit: cover;
}
._item_3t53z_1 ._name_3t53z_20 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
}
._item_3t53z_1 ._birthNumber_3t53z_26 {
  font-size: 14px;
  color: #787c88;
}
._item_3t53z_1 ._badgeWrapper_3t53z_30 {
  position: absolute;
  top: 0;
  left: 0;
}
._item_3t53z_1 ._verificationWrapper_3t53z_35 {
  position: absolute;
  right: 10px;
  top: 7px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  